/**
 * Created by Ivan on 16.09.2026
 */

const Merge2MissionOrangery = function (logic) {
    this.logic = logic;
};

Merge2MissionOrangery.VIEW_SCALE = 0.55;

Merge2MissionOrangery.VIEW_POSITION = {
    x: { align: "left", dx: 20 },
    y: { align: "bottom", dy: 20 }
};

Merge2MissionOrangery.TABS = [
    { icon: "tab_icon_valuable", codes: ["M"] },
    { icon: "tab_icon_booster", codes: ["GR"] },
    { icon: "tab_icon_source", codes: ["F"] },
    { icon: "tab_icon_chest", codes: ["T", "S", "N"] },
    { icon: "tab_icon_resource", codes: ["G", "E", "H"] }
];

Merge2MissionOrangery.prototype.init = function () {
    this.tabs = Merge2MissionOrangery.TABS.map((tab) => ({
        icon: bundles.windows.frames[tab.icon],
        rows: [[Merge2MissionOrangery.createEraser()]].concat(tab.codes.map(Merge2MissionOrangery.listUnits))
    }));
};

Merge2MissionOrangery.prototype.clear = function () {
    this.tabs = [];
};

Merge2MissionOrangery.isProtected = function (unit) {
    if (unit.findMinable()) {
        return true;
    }

    return Boolean(unit.getReward()) && !unit.findComponent(Merge2MissionGroundedComponent);
};

Merge2MissionOrangery.copyUnit = function (logic, unit) {
    const field = logic.field;
    if (!field.contains(unit) || !field.spawn(unit.code, unit.stage, undefined, unit)) {
        return;
    }

    logic.update();
};

Merge2MissionOrangery.removeUnit = function (logic, unit) {
    const field = logic.field;
    if (!field.contains(unit) || Merge2MissionOrangery.isProtected(unit)) {
        return;
    }

    const x = unit.x;
    const y = unit.y;

    field.removeUnit(x, y);

    if (unit.findComponent(Merge2MissionGroundedComponent)) {
        field.addUnit(x, y, field.createUnit(unit.code, unit.stage));
    }

    logic.update();
};

Merge2MissionOrangery.createEraser = function () {
    return {
        eraser: true,
        getItemIcon: () => new cc.Sprite(bundles.orangery.frames.eraser_icon),
        getMinimizedIcon: () => new cc.Sprite(bundles.orangery.frames.eraser_icon)
    };
};

Merge2MissionOrangery.listUnits = function (code) {
    return Merge2MissionFamilies.getStages(code).map((stage) => ({
        code,
        stage,
        getItemIcon: () => new cc.Sprite(Merge2MissionFamilies.getIcon(code, stage)),
        getMinimizedIcon: () => new cc.Sprite(Merge2MissionFamilies.getIcon(code, stage))
    }));
};

Merge2MissionOrangery.prototype.getItemCode = function (item) {
    return item.eraser ? "eraser" : Merge2MissionFamilies.getId(item.code, item.stage);
};

Merge2MissionOrangery.prototype.onClick = function (cell, selected) {
    const field = this.logic.field;

    if (!selected || !cell || !field.isActive(cell.x, cell.y)) {
        return false;
    }

    const unit = field.getUnit(cell.x, cell.y);

    if (selected.eraser) {
        if (!unit) {
            return false;
        }

        field.removeUnit(cell.x, cell.y);
    } else {
        if (unit) {
            return false;
        }

        field.addUnit(cell.x, cell.y, field.createUnit(selected.code, selected.stage));
        cleverapps.effects.fire("merge2mission.spawn.landing");
    }

    this.logic.update();

    return true;
};
